<script setup lang="ts">
import Icon from '../../../../../components/shared/Icon.vue'
import { useEpgWidgetTracking } from '../../../../../composables/use-epg-widget-tracking'

type FilterTag = {
  key: string,
  value?: string,
  label: string
}

defineProps<{
  tags: FilterTag[]
}>()

const emit = defineEmits<{
  'remove-filter': [tag: FilterTag]
}>()

const { trackEventInDataLayer } = useEpgWidgetTracking()

function handleRemove (tag: FilterTag) {
  emit('remove-filter', tag)
  // Google Analytics tracking
  trackEventInDataLayer('epg_filter_remove_click')
}
</script>

<template>
  <div v-if="tags.length"
       class="bx-epg-filter__tags">
    <strong>Gefiltert nach:</strong>
    <button v-for="tag in tags"
            :key="tag.key + (tag.value || '')"
            type="button"
            class="bx-epg-filter__tag"
            :data-tag-value="tag.value"
            :title="`Filter '${tag.label}' entfernen`"
            @click.prevent="handleRemove(tag)">
      {{ tag.label }}
      <Icon name="close" />
    </button>
  </div>
</template>
